import * as tslib_1 from "tslib";
import { encode } from '../jsonEncode';
import { BaseApiUrl, LoginApiUrl, UIClientTypes, } from '@tradingblock/types';
import { LogoutTokenUrl, NoPassLoginFinishUrl, NoPassLoginStartUrl } from '../constants';
import { verify } from '../utilities/JwtUtilities';
function isString(x) {
    return typeof x === 'string';
}
export function TryLogin(values, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const host = options.host || '';
        const loginUrl = host + (options.subdirectory ? options.subdirectory : '') + LoginApiUrl(options.subroot);
        return yield fetch(loginUrl, {
            method: 'post',
            body: JSON.stringify({ encoded: encode(values) }),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(res => res.json())
            .then(json => json);
    });
}
const httpOptions = {
    headers: { Accept: 'application/json' },
};
export const auth = (api) => {
    return {
        logout: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return api.authenticated().post(LogoutTokenUrl, {}, httpOptions);
        }),
    };
};
const tryVerify = (publicKey, token) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    try {
        var decoded = yield verify(publicKey, token, {
            clientType: [UIClientTypes.dashboard, UIClientTypes.application],
            algorithms: ['RS256'],
            ignoreExpiration: false,
        });
        if (!decoded || isString(decoded)) {
            console.warn('jwt response was invalid, an object was expected', decoded);
            return null;
        }
        else {
            const jwtValues = decoded;
            return { value: token, decoded: jwtValues };
        }
    }
    catch (err) {
        console.warn('token verification failed:', err);
        return null;
    }
});
export const verifyToken = (id_token, uiApi) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    const pubKey = yield fetch(`${BaseApiUrl}/publickey`).then(res => res.json());
    return yield tryVerify(pubKey.key, id_token);
});
export function TryNoPassLogin(values, host, loginUrl, setImage, setRequestInProgress, setNoPassError) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { username } = values;
        const noPassLoginStartUrl = host + '/' + NoPassLoginStartUrl + '?username=' + values.username;
        const noPassLoginFinishUrl = host + '/' + NoPassLoginFinishUrl + '?authid=';
        setRequestInProgress(true);
        try {
            const data1 = yield fetch(`${noPassLoginStartUrl}`, {
                method: 'post',
                body: JSON.stringify({ encoded: encode(values) }),
                headers: { 'Content-Type': 'application/json' },
            }).then(res => res.json());
            if (data1.Payload && data1.Payload.AuthId) {
                const authId = data1.Payload.AuthId;
                const image = data1.Payload.Image;
                setImage(image);
                const data2 = yield fetch(`${noPassLoginFinishUrl + authId}`).then(res => res.json());
                const tokenPayload = data2.Payload;
                if (tokenPayload) {
                    const uiTokenData = yield TryLogin({ username, password: '', apiToken: tokenPayload }, { host: loginUrl });
                    if (!uiTokenData.token) {
                        if (uiTokenData.reason && typeof uiTokenData.reason === 'string') {
                            setNoPassError(uiTokenData.reason);
                        }
                        else {
                            setNoPassError('NoPass Authentication Failed');
                        }
                        return;
                    }
                    const tokenResult = yield verifyToken(uiTokenData.token, loginUrl);
                    if (tokenResult) {
                        setRequestInProgress(false);
                        const { value, decoded } = tokenResult;
                        return Object.assign({}, decoded, { apiToken: tokenPayload, token: value, responseCode: data2.ResponseCode });
                    }
                    else {
                        setNoPassError('NoPass Authentication Failed');
                    }
                }
                else {
                    setNoPassError('User is not registered or the request has been denied.');
                }
            }
        }
        catch (error) {
            console.error('⬤ NoPass Authentication Error', error);
            setNoPassError(`NoPass Authentication Error: ${error}`);
        }
        setRequestInProgress(false);
        return null;
    });
}
//# sourceMappingURL=auth.js.map